/*@ngInject*/
const RulesBrowserActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function () {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.rules.model.Rule:null'
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('rulesBrowserActionRepository', RulesBrowserActionRepository);
